import React from "react";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { IconButton } from "@mui/material";
import { useSelector } from "react-redux";
import { addDoc, collection, deleteDoc, doc } from "firebase/firestore";
import { db } from "firebaseApp";
import { useAuth } from "context/react-lib/firebase-auth/AuthProvider";
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';

export default function AddFriendIconButton({ user }) {

  const auth = useAuth();
  const friendsState = useSelector((state) => state.collections.friends);

  if(!friendsState || friendsState.loading || !friendsState.documents) return null;

  const friend = friendsState.documents.find((f) => f.friendId === user.id);

  const handleToggleFriend = async () => {
    if(friend) {
      await deleteDoc(doc(db, "friends", friend.id));
    } else {
      await addDoc(collection(db, "friends"), {
        uid: auth.currentUser.uid,
        friendId: user.id,
      });
    }   
  }

  return (
    <IconButton
      onClick={handleToggleFriend}
      disabled={!auth.currentUser}
    >
      {friend ? (
        <PersonRemoveIcon />
      ) : (
        <PersonAddIcon />
      )}
    </IconButton>
  );

}
